'use client';
var IDENT = "Transition";
var defaultProps = {
    transition: "fade",
    duration: 250,
    exitDuration: 250,
    mounted: false
};

export { IDENT, defaultProps };
